export const environment = {
  production: true,
  debug: true,
};
